// Configuration settings for the application

// UI configurations
const UI_COLORS = {
  primary: '#05A0C7',
  primaryDark: '#0481A0',
  secondary: '#13294B',
  background: '#EBF1FA',
  white: '#ffffff',
};

export {
  UI_COLORS
};
